import BaseNumberVTextField from './BaseNumberVTextField'
import { formatPhoneNumber } from '~/cynqueModules/formatPhoneNumber'

// Vuetify 3 migration: wraps <v-text-field> via BaseNumberVTextField, but unlike the
// numeric fields the phone number is stored FORMATTED — commitBlur formats AND commits
// the value to the model (blur-commit), with no raw-revert on refocus (the model is
// already the formatted string, so the inherited rawForEditing shows it as-is).
// parseNumeric:false — a phone number is not parsed as a number.
export default {
  extends: BaseNumberVTextField,
  props: {
    parseNumeric: {
      type: Boolean,
      default: false,
    },
    blurredFormat: {
      type: Function,
      default: (v: string) => (v ? formatPhoneNumber(v) : v),
    },
  },
  methods: {
    // Commit the FORMATTED value to the model (phone is stored formatted), then
    // re-validate. The base's commitBlur reformats the display only; phone additionally
    // emits so the saved value is the formatted string.
    commitBlur() {
      const self = this as any
      self.display = self.formatForDisplay(self.display)
      self.$emit('update:modelValue', self.display)
      self.$nextTick(() => self.$refs.field?.validate?.())
    },
  },
}
